"use client";

import { Typography } from "@/components/ui/typography";
import type { ServicesUseCasesProps } from "./types";
import { servicesUseCasesMap } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { CasesCardCarousel } from "@/components/screen/global-components/cases";

const ServicesUseCases = ({
  variant = "standard",
  className,
}: ServicesUseCasesProps) => {
  const {
    cards,
    content: { title, description, exploreText },
  } = servicesUseCasesMap[variant];

  const variantSecondary = ["enterprise", "urgent"].includes(variant);

  return (
    <section
      className={cn(
        "section overflow-hidden bg-background-secondary",
        className
      )}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div
          className={cn(
            "flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[900] md:mx-auto md:text-center",
            {
              "md:max-w-[746]": variantSecondary,
            }
          )}
        >
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600 w-full max-w-[746] mx-auto">
            <Typography variant="subHeadingSm" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <CasesCardCarousel
          cards={cards}
          exploreText={exploreText}
          className="mt-6 lg:!mt-12"
        />
      </div>
    </section>
  );
};

export default memo(ServicesUseCases);
